
const CustomLoading = () => {
  return (
    <>
      <div className="main_loading_section"></div>
      <div className="loading_image">
        <div className="loading_brand">
          <div className="bm_logo_mark">BE</div>
          <div className="loading_brand_text">TIN</div>
          <div className="loading_spinner" />
        </div>
      </div>
    </>
  );
};

export default CustomLoading;
